import { CheckBox } from '@common-fe/common-fe';
import styled from 'styled-components';

export const HeaderCheckBox = styled(CheckBox)`
  && + div {
    width: ${({ theme }) => theme.spacings.spacing16};
    height: ${({ theme }) => theme.spacings.spacing16};
    border-radius: ${({ theme }) => theme.spacings.spacing4};
  }
`;
